import React from 'react';

export const SvgVolumeOff = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.63 5.045a.996.996 0 010-1.41c.4-.39 1.03-.39 1.42 0l15.31 15.32a.996.996 0 11-1.41 1.41l-1.34-1.34c-.67.54-1.42.98-2.22 1.31-.66.27-1.39-.19-1.39-.91 0-.39.22-.77.58-.92.58-.23 1.11-.54 1.6-.91L12 13.415v4.17c0 .89-1.08 1.34-1.71.71L7 15.005H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3l.29-.3-3.66-3.66zm14.96 9.3c.26-.73.41-1.52.41-2.34 0-2.94-1.82-5.46-4.39-6.5-.36-.14-.61-.47-.61-.85v-.19c0-.63.63-1.09 1.22-.86a8.995 8.995 0 015.78 8.4c0 1.39-.32 2.7-.88 3.87l-1.53-1.53zm-8.3-8.63l-.17.17L12 7.765v-1.35c0-.89-1.08-1.33-1.71-.7zM14 7.975a4.5 4.5 0 012.5 4.03c0 .08-.01.16-.02.24L14 9.765v-1.79z"
      fill="currentColor"
    />
  </svg>
);
